<template>
  <div class="footer">
    <div :class="'layout-container'">
      <div class="descriptionContainer">
        <div class="textContainer">
          <HgIcon :icon="Icon.Premium" color="secondary" size="large" class="icon" />
          <div class="description">
            <span class="heading">{{ t('footerBanner.title') }}</span>
            <span class="text">{{ t('footerBanner.text') }}</span>
          </div>
        </div>
        <HgButton ref="ctaButton" class="ctaBtn" :size="ButtonSize.Large" @click="goToValuation">
          {{ t('landing.actionableHerobox.start') }}
        </HgButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { VALUATION_FUNNEL_PATH } from '@/router/routes/constants';
import { trackingClickEvent } from '@/tracking/tracking';
import { TRACKING_ACTION, TRACKING_LABEL } from '@/tracking/types';
import { ButtonSize, HgButton, HgIcon, Icon } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n();
const isIs24 = isPlatformIs24();
const router = useRouter();
const { locale } = useI18n();

const goToValuation = () => {
  trackingClickEvent(TRACKING_ACTION.GO_TO_VALUATION_FUNNEL, TRACKING_LABEL.FLOATING_BANNER);
  router.push(`${VALUATION_FUNNEL_PATH[locale.value]}`);
};
</script>

<style lang="scss" scoped>
@use '@/assets/variables' as *;
.footer {
  position: sticky;
  bottom: 0;
  width: 100%;
  z-index: 15;
  background-color: $color-white;
  box-shadow: 0px 6px 24px 0px #0000001a;
  opacity: 0;
  transform: translateY(16px);
  animation: fadeInUp 400ms ease forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ctaBtn {
  height: $space-250;
  width: 100%;
  align-self: center;
  @include grid-media-query(sm) {
    width: max-content;
  }
}

.descriptionContainer {
  display: flex;
  flex-direction: row;
  padding: $space-100 0;
  @include grid-media-query(sm) {
    justify-content: space-between;
  }
}

.textContainer {
  display: none;
  flex-direction: row;
  gap: $space-50;

  @include grid-media-query(sm) {
    display: flex;
  }
}

.description {
  display: flex;
  flex-direction: column;
  column-gap: $space-25;
}

.heading {
  @include body-2-semi-bold;
}

.text {
  @include body-2;
}

.icon {
  height: $space-150;
  width: $space-150;
}
</style>
